import i18n from '../../../i18n';

export const preloadedNamespaces = [
  'advanced-analysis-item',
  'cards',
  'command',
  'common',
  'microphone',
  'notifications',
  'performance',
  'requests',
  'session',
  'session-event',
  'settings',
  'translation',
  'widgets',
  'wysiwyg',
] as const;

let preloadPromise: Promise<unknown> | null = null;

export default function preloadTranslations() {
  if (!preloadPromise) {
    preloadPromise = i18n.loadNamespaces([...preloadedNamespaces]);
  }

  return preloadPromise;
}
